import { computed, ref } from 'vue';
import { useTask } from '@/ui/concerns';
import { list } from '@/services/api/resources/aiPhotoValidation';
import { AiPhotoValidationListParams } from '@/services/api/resources/aiPhotoValidation/query';

export const useAiPhotoValidationCheck = () => {
  const checkResult = ref<boolean | undefined>();

  const query = (): AiPhotoValidationListParams => ({
    page: 1,
    perPage: 1,
  });

  const performCheck = useTask(
    () => list(query()),
    listResponse => {
      checkResult.value = listResponse.data.length > 0;
    },
  );

  const taskReportCheck = computed(() => performCheck);

  return {
    checkResult,
    taskReportCheck,
    performCheck,
  };
};
